function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useMemo, useRef, useEffect } from "react";
import { NAVIGATION_LINK_CLICKED, FILTER_TYPING_STARTED, READ_MORE_CLICKED } from "constants/bigbrain-event-types";
import SecondaryButton from "segments/desktop/core-components/button/secondary-button/secondary-button";
import { ID_TO_OPTIONS_NAMES_AND_COLORS } from "components/pages/whats-new/consts";
import { StyledWhatsNewPageItemsList } from "./whats-new-items-list.scss";
import WhatsNewItemTag from "./tag/tag";
import WhatsNewPageFilters from "./filters/filters";
import { filterItems, PRODUCT_TAG_TYPE, TEAM_TAG_TYPE, RELEASE_STATUS_TAG_TYPE, RELEASE_TYPE_TAG_TYPE } from "../utils";
import AssetComponent from "/components/core/asset/asset-component";
import { trackEvent } from "/services/bigbrain-service";
import { filtersSchema } from "../consts";
import { getCleanedFilterSchema } from "../utils";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import YouTubePopupButton from "segments/desktop/core-components/button/youtube-popup-button/youtube-popup-button";
import { BRAND_BLACK_TEXT_COLOR } from "styles/color-consts";
import classnames from "classnames";
import { getReleaseTypeIcon } from "components/pages/whats-new/utils";
import Title from "segments/desktop/core-components/title/title";
import { SM } from "constants/sizes";
import { getUrlParamValueFromCurrentLocation } from "utils/url";
const initialFilterValues = filtersSchema.reduce((acc, { id })=>{
    acc[id] = [];
    return acc;
}, {});
const WhatsNewPageItemsList = (props)=>{
    const { itemsArray, textSearch: textSearchProp, filterValues: filterValuesProp, isMobile, monthlyVideosSet, productFilterValue, hideProductFilter } = props;
    const [page, setPage] = useState(1);
    const [filterValues, setFilterValues] = useState(filterValuesProp || initialFilterValues);
    const [textSearch, setTextSearch] = useState(textSearchProp || "");
    const MOBILE_ITEMS_PER_PAGE_COUNT = 8;
    const DESKTOP_ITEMS_PER_PAGE_COUNT = 400;
    const itemsPerPage = isMobile ? MOBILE_ITEMS_PER_PAGE_COUNT : DESKTOP_ITEMS_PER_PAGE_COUNT;
    const DEFAULT_IMAGE_URL = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/3.png";
    const EMPTY_STATE_IMAGE_URL = "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Whats%20new%20page/empty_state_image.svg";
    const WATCH_NOW_TEXT = "Watch now";
    const ALL_UPDATES_AND_RELEASES = "All Updates & Releases";
    const teamFilter = getUrlParamValueFromCurrentLocation("team");
    useEffect(()=>{
        let newFilterValues = filterValuesProp || initialFilterValues;
        if (teamFilter && Object.keys(ID_TO_OPTIONS_NAMES_AND_COLORS.team.data).includes(teamFilter)) {
            const tempFilterValues = _object_spread_props(_object_spread({}, newFilterValues), {
                team: [
                    teamFilter
                ]
            });
            const tempFilteredItems = filterItems(itemsArray, tempFilterValues, textSearch);
            if (tempFilteredItems.length > 0) {
                newFilterValues = tempFilterValues;
            }
        }
        if (productFilterValue && Object.keys(ID_TO_OPTIONS_NAMES_AND_COLORS.product.data).includes(productFilterValue)) {
            const tempFilterValues = _object_spread_props(_object_spread({}, newFilterValues), {
                product: [
                    productFilterValue
                ]
            });
            const tempFilteredItems = filterItems(itemsArray, tempFilterValues, textSearch);
            if (tempFilteredItems.length > 0) {
                newFilterValues = tempFilterValues;
            }
        }
        setFilterValues(newFilterValues);
    }, [
        filterValuesProp,
        teamFilter,
        itemsArray,
        textSearch,
        productFilterValue
    ]);
    const filteredItems = useMemo(()=>{
        itemsArray.sort((a, b)=>{
            const dateA = new Date(a.fullDate);
            const dateB = new Date(b.fullDate);
            return dateB - dateA;
        });
        return filterItems(itemsArray, filterValues, textSearch);
    }, [
        itemsArray,
        filterValues,
        textSearch
    ]);
    const totalPageCount = Math.ceil(filteredItems.length / itemsPerPage);
    const paginatedItems = filteredItems.slice((page - 1) * itemsPerPage, page * itemsPerPage);
    const itemsExist = paginatedItems.length > 0;
    const squareListRef = useRef();
    const cleanedFiltersSchema = useMemo(()=>getCleanedFilterSchema(filtersSchema, itemsArray), [
        filtersSchema,
        itemsArray
    ]);
    const scrollToTop = ()=>{
        const offsetTop = squareListRef.current.offsetTop;
        const headerOffset = isMobile ? 200 : 100;
        window.scrollTo({
            top: offsetTop - headerOffset,
            behavior: "smooth"
        });
    };
    const handlePageChange = (newPage)=>{
        setPage(newPage);
        scrollToTop();
        trackEvent(NAVIGATION_LINK_CLICKED);
    };
    const handleFiltersChange = (newFilterValues)=>{
        setFilterValues(newFilterValues);
        setPage(1);
        scrollToTop();
    };
    const handleTextSearchChange = (event)=>{
        if ((textSearch === null || textSearch === void 0 ? void 0 : textSearch.length) === 0) {
            trackEvent(FILTER_TYPING_STARTED);
        }
        setTextSearch(event.target.value);
        setPage(1);
    };
    const renderPagination = ()=>{
        return /*#__PURE__*/ _jsxs("div", {
            className: "pagination-wrapper",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "line-dot-container",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "vertical-line"
                    })
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "pagination",
                    children: [
                        page > 1 && /*#__PURE__*/ _jsx("span", {
                            className: "pagination-button",
                            onClick: ()=>handlePageChange(page - 1),
                            tabIndex: 0,
                            onKeyDown: generateOnKeyDownHandler(()=>{
                                handlePageChange(page + -1);
                            }),
                            role: "button",
                            "aria-label": "Previous page",
                            children: "< Back"
                        }),
                        /*#__PURE__*/ _jsxs("span", {
                            children: [
                                page,
                                " / ",
                                totalPageCount
                            ]
                        }),
                        page < totalPageCount && /*#__PURE__*/ _jsx("span", {
                            className: "pagination-button",
                            onClick: ()=>handlePageChange(page + 1),
                            tabIndex: 0,
                            onKeyDown: generateOnKeyDownHandler(()=>{
                                handlePageChange(page + 1);
                            }),
                            role: "button",
                            "aria-label": "Next page",
                            children: "Next >"
                        })
                    ]
                })
            ]
        });
    };
    const readMoreClicked = (item)=>{
        trackEvent(READ_MORE_CLICKED, {
            kind: item === null || item === void 0 ? void 0 : item.title
        });
    };
    const renderEmptyMessage = ()=>{
        return /*#__PURE__*/ _jsxs("div", {
            className: "empty-state",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "empty-state",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "empty-message-title",
                            children: "No results found"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "empty-message-subtitle",
                            children: "Please edit your search and try again."
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(AssetComponent, {
                    image: {
                        src: EMPTY_STATE_IMAGE_URL
                    }
                })
            ]
        });
    };
    const renderTags = (item)=>{
        var _item_product;
        return /*#__PURE__*/ _jsx("div", {
            className: "tags-wrapper",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "left-tags-wrapper",
                children: [
                    (_item_product = item.product) === null || _item_product === void 0 ? void 0 : _item_product.map((product)=>product && /*#__PURE__*/ _jsx(WhatsNewItemTag, {
                            tagId: product,
                            tagType: PRODUCT_TAG_TYPE
                        })),
                    isMobile && item.releaseType != null && /*#__PURE__*/ _jsx(WhatsNewItemTag, {
                        tagId: item.releaseType,
                        tagType: RELEASE_TYPE_TAG_TYPE
                    }),
                    item.team != null && /*#__PURE__*/ _jsx(WhatsNewItemTag, {
                        tagId: item.team,
                        tagType: TEAM_TAG_TYPE
                    })
                ]
            })
        });
    };
    const renderItem = (item, index)=>{
        var _paginatedItems_, _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE_data_item_releaseType, _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE, _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE_data_item_releaseType1, _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE1;
        const currentItemFormattedDate = item.monthDate;
        const lastItemFormattedDate = (_paginatedItems_ = paginatedItems[index - 1]) === null || _paginatedItems_ === void 0 ? void 0 : _paginatedItems_.monthDate;
        const showDateTitle = isMobile || currentItemFormattedDate !== lastItemFormattedDate;
        const monthlyVideoId = item.monthYearDate ? monthlyVideosSet === null || monthlyVideosSet === void 0 ? void 0 : monthlyVideosSet.get(item.monthYearDate) : null;
        const releaseTypeName = (_ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE = ID_TO_OPTIONS_NAMES_AND_COLORS[RELEASE_TYPE_TAG_TYPE]) === null || _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE === void 0 ? void 0 : (_ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE_data_item_releaseType = _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE.data[item.releaseType]) === null || _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE_data_item_releaseType === void 0 ? void 0 : _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE_data_item_releaseType.name;
        const releaseTypeColor = (_ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE1 = ID_TO_OPTIONS_NAMES_AND_COLORS[RELEASE_TYPE_TAG_TYPE]) === null || _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE1 === void 0 ? void 0 : (_ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE_data_item_releaseType1 = _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE1.data[item.releaseType]) === null || _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE_data_item_releaseType1 === void 0 ? void 0 : _ID_TO_OPTIONS_NAMES_AND_COLORS_RELEASE_TYPE_TAG_TYPE_data_item_releaseType1.color;
        const isFirstItemOnPage = index === 0;
        const isLastItem = index === paginatedItems.length - 1;
        const BOTTOM_CARD_MARGIN = "24px";
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                showDateTitle && !isMobile && /*#__PURE__*/ _jsxs("div", {
                    className: "desktop-date-title",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "line-dot-container",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: classnames("vertical-line", {
                                        "page-first-item": isFirstItemOnPage
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "date-dot",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "inner-dot"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "outer-ring"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "date-content",
                            children: [
                                /*#__PURE__*/ _jsx("b", {
                                    children: item.monthDate
                                }),
                                monthlyVideoId && /*#__PURE__*/ _jsxs("div", {
                                    className: "popup-button-wrapper",
                                    children: [
                                        " | ",
                                        /*#__PURE__*/ _jsx(YouTubePopupButton, {
                                            buttonText: WATCH_NOW_TEXT,
                                            isWithIcon: true,
                                            isWithIconInsteadOfArrow: true,
                                            withoutUnderline: true,
                                            iconColor: BRAND_BLACK_TEXT_COLOR,
                                            videoId: monthlyVideoId
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "square-wrapper",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "line-dot-container",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "vertical-line"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "dot"
                                })
                            ]
                        }),
                        showDateTitle && isMobile && /*#__PURE__*/ _jsx("div", {
                            className: "mobile-date-title",
                            children: item.fullDate
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "square",
                            style: {
                                marginBottom: isLastItem ? BOTTOM_CARD_MARGIN : 0
                            },
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "content-wrapper",
                                    children: [
                                        isMobile && renderTags(item),
                                        !isMobile && /*#__PURE__*/ _jsxs("div", {
                                            className: "card-top-part-wrapper",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "release-type-icon",
                                                    children: getReleaseTypeIcon(item.releaseType)
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "release-type-name",
                                                    style: {
                                                        color: releaseTypeColor
                                                    },
                                                    children: releaseTypeName
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "separator-dot",
                                                    style: {
                                                        color: releaseTypeColor
                                                    },
                                                    children: "•"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "full-date-title",
                                                    children: item.partialDate
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "name",
                                            children: item.title
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "description",
                                            children: item.shortText
                                        }),
                                        item.articleLink && /*#__PURE__*/ _jsx("div", {
                                            className: "read-more",
                                            onClick: ()=>readMoreClicked(item),
                                            children: /*#__PURE__*/ _jsx(SecondaryButton, {
                                                buttonText: "Read more",
                                                url: item.articleLink,
                                                withoutUnderline: true,
                                                isOpenLinkInNewTab: true
                                            })
                                        }),
                                        !isMobile && renderTags(item),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "image-wrapper mobile-image-wrapper",
                                            children: /*#__PURE__*/ _jsx(AssetComponent, {
                                                image: {
                                                    src: (item === null || item === void 0 ? void 0 : item.cloudinaryUrl) || DEFAULT_IMAGE_URL
                                                }
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "image-wrapper desktop-image-wrapper",
                                    children: /*#__PURE__*/ _jsx(AssetComponent, {
                                        image: {
                                            src: (item === null || item === void 0 ? void 0 : item.cloudinaryUrl) || DEFAULT_IMAGE_URL
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                }, `${item === null || item === void 0 ? void 0 : item.title}`)
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(StyledWhatsNewPageItemsList, {
        className: "square-list-container",
        ref: squareListRef,
        children: [
            !isMobile && /*#__PURE__*/ _jsx(WhatsNewPageFilters, {
                filtersSchema: cleanedFiltersSchema,
                filterValues: filterValues,
                onChange: handleFiltersChange,
                setFilterValues: setFilterValues,
                handleTextSearchChange: handleTextSearchChange,
                textSearch: textSearch,
                itemsArray: itemsArray,
                hideProductFilter: hideProductFilter
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: classnames("square-list", {
                    "empty-list": !itemsExist
                }),
                children: [
                    !isMobile && itemsExist && /*#__PURE__*/ _jsx("div", {
                        className: "square-list-title",
                        children: /*#__PURE__*/ _jsx(Title, {
                            title: ALL_UPDATES_AND_RELEASES,
                            titleSize: SM
                        })
                    }),
                    itemsExist ? paginatedItems.map((item, index)=>renderItem(item, index)) : renderEmptyMessage(),
                    paginatedItems.length === 1 && /*#__PURE__*/ _jsx("div", {
                        className: classnames("square-wrapper", "placeholder"),
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "line-dot-container",
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "vertical-line"
                            })
                        })
                    }),
                    totalPageCount > 1 && renderPagination()
                ]
            })
        ]
    });
};
export default WhatsNewPageItemsList;
